<template>
  <div class="pagination" v-if="total >= size">
    <!-- FIRST PAGE -->
    <span class="pagination-item" v-if="page > 1" @click="changePage(page - 1)">
      <span class="kcm">D</span>
    </span>
    <span class="pagination-item" v-if="page > 2" @click="changePage(1)">1</span>
    <span class="pagination-item pagination-dots" v-if="page > 3">...</span>
    <span class="pagination-item" v-if="page > 1" @click="changePage(page - 1)">{{ page - 1 }}</span>
    <span class="pagination-item pagination-current">{{page}}</span>
    <span
      class="pagination-item"
      v-if="page <  Math.ceil(total / size) - 1"
      @click="changePage(page + 1)"
    >{{ page + 1 }}</span>
    <span class="pagination-item pagination-dots" v-if="page <  Math.ceil(total / size) - 2">...</span>
    <!-- LAST PAGE -->
    <span
      class="pagination-item"
      v-if="page !== Math.ceil(total / size) && Math.ceil(total / size)"
      @click="changePage(Math.ceil(total / size))"
    >{{Math.ceil(total / size)}}</span>
    <span
      class="pagination-item"
      v-if="page <  Math.ceil(total / size)"
      @click="changePage(page + 1)"
    >
      <span class="kcm">B</span>
    </span>
  </div>
</template>

<script>
export default {
  props: ["total", "size", "page"],
  methods: {
    changePage(p) {
      this.$parent.$emit("page-changed", p);
    }
  }
};
</script>

<style>
</style>
